import React, { useState } from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import DropdownWithHeader from '../../../../Utils/CommonComponents/DashboardsCommon/DropdownWithHeader'
import { monthlyDropdownList } from '../../../../Data/DashboardsData/ECommerceData'
import { GrossCategoriesTitle } from '../../../../Utils/Constants'
import DataTable from 'react-data-table-component'
import { grossCategoriesColumns, grossCategoriesData } from '../../../../Data/DashboardsData/DefaultData'
import FilterComponent from '../../Common/FilterComponent'
import { GrossCategoriesType } from '../../../../Types/DashboardsType'

export default function GrossCategories() {
    const [filterText, setFilterText] = useState('');
    const filteredItems: GrossCategoriesType[] = grossCategoriesData.filter(
        (item: GrossCategoriesType) => {
            return Object.values(item).some((value) =>
                value && value.toString().toLowerCase().includes(filterText.toLowerCase())
            );
        }
    );
    return (
        <Col xl={7} className="box-col-12">
            <Card>
                <DropdownWithHeader headerClass='pb-0' heading={GrossCategoriesTitle}
                    dropDownClass='icon-dropdown' dropDownIcon dropDownList={monthlyDropdownList} />
                <CardBody className="px-0 report">
                    <FilterComponent
                        onFilter={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
                        filterText={filterText}
                    />
                    <div className="table-responsive custom-scrollbar">
                        <DataTable data={filteredItems} columns={grossCategoriesColumns} className='display' />
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}